import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { map, size } from "lodash";
import { AssistanceApi } from "../../../../api";
import { AssistanceItem } from "../AssistanceItem";
import { useAuth } from "../../../../hooks"; // aqui obtenemos el token del usuario autenticado
import "./ListAssistance.scss";

const assistnceController = new AssistanceApi();

export function ListAssistance(props) {
  const { reload, onReload } = props;
  const { accessToken } = useAuth(); //obtenemos el token del usuario autenticado

  const [assistances, setAssistances] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      try {
        const response = await assistnceController.getAssistances(
          accessToken,
          page,
        );
        setAssistances(response.assistances.docs);
        //console.log(response);
        setPagination({
          total: response.assistances.totalDocs,
          page: response.assistances.page,
          limit: response.assistances.limit,
          pages: response.assistances.totalPages,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page, reload, accessToken]);

  const changePage = (e, data) => {
    setPage(data.activePage);
  };

  if (!assistances) return <Loader active inline="centered" />;
  if (size(assistances) === 0) return <h2>No hay Asistentes</h2>;

  return (
    <div className="list-assistance">
      {map(assistances, (assistance) => (
        <AssistanceItem
          key={assistance._id}
          assistance={assistance}
          onReload={onReload}
        />
      ))}

      <div className="list-assistance__pagination">
        <Pagination
          defaultActivePage={pagination.page}
          totalPages={pagination.pages}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
